/* eslint-disable max-len */
import React, {Component} from 'react';
import {withApollo} from 'react-apollo';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import creditsQuery from 'graphql/queries/credits.gql';
import Spinner from 'components/spinner';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import Filters from 'components/filters';
import CreditChart from 'components/credit-chart';
import CreditDetail from 'components/credit-detail';
import CreditHistory from 'components/credit-history';
import styles from './styles.css';

@withApollo
@autobind
export default class CreditSummary extends Component {
    state = {
        data: {},
        loading: false,
    };

    componentDidMount() {
        const {match: {params: {id: organization}}} = this.props;
        if (organization) this.loadData({organization: Number(organization)});
    }

    async loadData(filters) {
        this.setState({loading: true});
        const response = await this.props.client.query({
            fetchPolicy: 'network-only',
            query: creditsQuery,
            variables: {
                season: filters.season || undefined,
                organization: filters.organization || undefined,
            },
        });
        this.setState({data: response.data, loading: false});
    }

    async handleFilterChange(filters) {
        this.loadData(filters);
    }

    renderContent() {
        const {loading, data: {creditSummary, transactions, transactionsByCategory}} = this.state;
        if (loading) return <Spinner />;

        const content = [];
        if (creditSummary && transactionsByCategory) {
            content.push(
                <CreditDetail key='credit-detail' creditDetail={creditSummary.creditDetail} />,
                <CreditChart key='chart' creditSummary={creditSummary} transactionsByCategory={transactionsByCategory} />,
            );
        }
        if (transactions) {
            content.push(
                <SectionTitle key='history-label' title='Movimientos' subtitle='Historial de créditos y débitos de la cuenta de la organización.' />,
                <CreditHistory key='history' transactions={transactions} />,
            );
        }
        return content;
    }

    render() {
        const renderFilters = !this.props.match.params.id;
        return (
            <div className={styles.root}>
                {renderFilters && (
                    <div className={styles.background} />
                )}
                <SectionBanner />
                {renderFilters && (
                    <div className={styles.filters}>
                        <Filters filters={['organization', 'season']} onChange={this.handleFilterChange} />
                    </div>
                )}
                <div className={classNames(styles.container, {[styles.hasFilters]: renderFilters})}>
                    <div className={styles.content}>{this.renderContent()}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/credit-summary/index.js